'use client';

import { PortableTextSimple } from '@/components/portable-text/portable-text-simple';
import type { AnnouncementBannerProps } from '@/layout/announcement-banner/announcement-banner';
import { portableTextModuleStyles } from '@/lib/utils';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@veranda/shared/components/ui/carousel';
import { cn } from '@veranda/shared/lib';
import Autoplay from 'embla-carousel-autoplay';

export function AnnouncementBannerCarousel({
  content,
  className,
}: {
  content: NonNullable<AnnouncementBannerProps['content']>;
  className?: string;
}) {
  const displayItems =
    content.type === 'multiple' ? content.items : [content.content];

  if (!displayItems) return null;

  return (
    <Carousel
      className={className}
      opts={{
        align: 'center',
        loop: true,
      }}
      plugins={[
        Autoplay({
          delay: 4000,
        }),
      ]}
    >
      <div className="relative flex items-center overflow-x-hidden">
        <CarouselContent>
          {displayItems
            .filter((item): item is NonNullable<typeof item> => item !== null)
            .map((item) => (
              <CarouselItem
                key={Array.isArray(item) ? item[0]?._key : item._key}
                className="min-h-[3rem]"
              >
                <div
                  className={cn(
                    portableTextModuleStyles,
                    'flex h-full items-center justify-center px-4 text-center [&_p]:mb-0'
                  )}
                >
                  <PortableTextSimple
                    content={Array.isArray(item) ? item : [item]}
                    className="mt-0 mb-0"
                  />
                </div>
              </CarouselItem>
            ))}
        </CarouselContent>
      </div>
    </Carousel>
  );
}
